"use client";

import { useQuery } from '@tanstack/react-query'
import { getApi } from "@src/config/apiWithAxios"
import { URL_LIST_LISTING } from "@src/constant/api-url"
import { KEY_DETAIL_LISTING } from "@src/constant/query-keys/list-listing"

const getDetailListing = async ({ queryKey }) => {
  const [_key, { requestUrl, params }] = queryKey;
  const res = await getApi(requestUrl, params);

  return res?.data?.data
}

export const useQueryGetDetailListing = (slug) => {
  const dependencies = {
    requestUrl: URL_LIST_LISTING + `/${slug}`
  }
  
  return useQuery({
    queryKey: [KEY_DETAIL_LISTING, dependencies],
    queryFn: getDetailListing,
    enabled: !!slug
  })
}
